export default "__VITE_ASSET__97e3f3c7__"